import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { BlockUIModule } from 'primeng/blockui';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from 'primeng/chips';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ContextMenuModule } from 'primeng/contextmenu';
import {DataViewModule} from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { GalleriaModule } from 'primeng/galleria';
import { ImageModule } from 'primeng/image';
import { InputMaskModule } from 'primeng/inputmask';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ListboxModule } from 'primeng/listbox';
import { MegaMenuModule } from 'primeng/megaMenu';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgModule } from '@angular/core';
import { OrderListModule } from 'primeng/orderlist';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PanelModule } from 'primeng/panel';
import { PasswordModule } from 'primeng/password';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PickListModule } from 'primeng/picklist';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SelectButtonModule } from 'primeng/selectbutton'
import { SidebarModule } from 'primeng/sidebar';
import { SlideMenuModule } from 'primeng/slidemenu';
import { SliderModule } from 'primeng/slider';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SplitterModule } from 'primeng/splitter';
import {StepsModule} from 'primeng/steps';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { ToastModule } from 'primeng/toast';
import {ToggleButtonModule} from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';

@NgModule({
  declarations: [],
  imports: [
    ButtonModule,
    FileUploadModule,
    MenuModule,
    MenubarModule,
    TabMenuModule,
    CardModule,
    InputTextModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextareaModule,
    PanelModule,
    TableModule,
    ChipModule,
    PaginatorModule,
    SplitButtonModule,
    DropdownModule,
    SidebarModule,
    SlideMenuModule,
    CalendarModule,
    BadgeModule,
    ProgressBarModule,
    BreadcrumbModule,
    DialogModule,
    ListboxModule,
    ToastModule,
    ConfirmDialogModule,
    MultiSelectModule,
    ProgressSpinnerModule,
    ScrollPanelModule,
    AutoCompleteModule,
    CheckboxModule,
    AccordionModule,
    SliderModule,
    InputSwitchModule,
    TabViewModule,
    RadioButtonModule,
    PdfViewerModule,
    TieredMenuModule,
    SelectButtonModule,
    SplitterModule,
    TreeModule,
    BlockUIModule,
    OverlayPanelModule,
    InputMaskModule,
    ContextMenuModule,
    FieldsetModule,
    AccordionModule,
    CascadeSelectModule,
    DynamicDialogModule,
    TooltipModule,
    MegaMenuModule,
    PanelMenuModule,
    AvatarModule,
    AvatarGroupModule,
    CarouselModule,
    DividerModule,
    ImageModule,
    GalleriaModule,
    PasswordModule,
    ToolbarModule,
    ConfirmPopupModule,
    TagModule,
    ChipsModule,
    OrderListModule,
    PickListModule,
    DataViewModule,
    ToggleButtonModule,
    StepsModule
  ],
  exports: [
    FileUploadModule,
    MenuModule,
    MenubarModule,
    TabMenuModule,
    CardModule,
    InputTextModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextareaModule,
    PanelModule,
    TableModule,
    ChipModule,
    PaginatorModule,
    SplitButtonModule,
    DropdownModule,
    SidebarModule,
    SelectButtonModule,
    SlideMenuModule,
    CalendarModule,
    BadgeModule,
    ProgressBarModule,
    BreadcrumbModule,
    DialogModule,
    ListboxModule,
    ToastModule,
    ConfirmDialogModule,
    MultiSelectModule,
    ProgressSpinnerModule,
    ScrollPanelModule,
    AutoCompleteModule,
    CheckboxModule,
    AccordionModule,
    SliderModule,
    InputSwitchModule,
    TabViewModule,
    RadioButtonModule,
    PdfViewerModule,
    TieredMenuModule,
    SplitterModule,
    TreeModule,
    BlockUIModule,
    OverlayPanelModule,
    InputMaskModule,
    ContextMenuModule,
    FieldsetModule,
    AccordionModule,
    CascadeSelectModule,
    DynamicDialogModule,
    TooltipModule,
    MegaMenuModule,
    PanelMenuModule,
    AvatarModule,
    AvatarGroupModule,
    CarouselModule,
    DividerModule,
    ImageModule,
    GalleriaModule,
    PasswordModule,
    ToolbarModule,
    ConfirmPopupModule,
    TagModule,
    ChipsModule,
    OrderListModule,
    PickListModule,
    DataViewModule,
    ToggleButtonModule,
    StepsModule
  ],
})
export class PrimeNGModuleModule {}
